import { Component, ViewChild } from '@angular/core';
import { CoreFileUploadDialogComponent } from '../../../pages/organization/organization-create/create-organization-tab-three/add-file-modal/add-file-modal.component';

@Component({
  selector: 'call-upload-file-dialog',
  templateUrl: './call-upload-file-dialog.component.html',
  styleUrl: './call-upload-file-dialog.component.scss',
})
export class CallUploadFileComponent {
  visible: boolean = false;

  selectedId: number = 1; // Varsayılan olarak ilk buton seçili
  @ViewChild('callUploadFileDialog')
  fileUploadDialog: CoreFileUploadDialogComponent;

  buttons = [
    { id: 1, label: 'call-file-dialog.portal' },
    { id: 2, label: 'call-file-dialog.ipad' },
    { id: 3, label: 'call-file-dialog.patient-relative' },
  ];

  files = [
    {
      id: 1,
      name: 'Hasta Kimlik',
      description: 'Açıklama',
      user: 'Hasta/Hasta Yakını',
      userIcon: 'pi pi-user',
      date: '04.03.2025 14:05',
      type: 1,
    },
    {
      id: 2,
      name: 'EKG Sonucu',
      description: 'Açıklama',
      user: 'Musa Aslan',
      userIcon: 'pi pi-ambulance',
      date: '04.03.2025 13:58',
      type: 2,
    },
    {
      id: 3,
      name: 'Hasta Kimlik',
      description: 'Açıklama',
      user: 'Doğukan Öncüer',
      userIcon: 'pi pi-desktop',
      date: '04.03.2025 13:45',
      type: 3,
    },
    {
      id: 3,
      name: 'Hasta 2',
      description: 'Açıklama',
      user: 'Dodocino',
      userIcon: 'pi pi-desktop',
      date: '04.03.2025 13:45',
      type: 2,
    },
  ];

  filteredFiles = this.files.filter((f) => f.type === this.selectedId);

  constructor() {}


  closeDialog() {
    this.visible = false;
  }

  cancelDialog() {
    this.closeDialog();
  }

  openDialog() {
    this.visible = true;
  }

  contiune() {
  }

  addFile() {
    this.fileUploadDialog.initialize([]);
  }

  deleteFile(item: any) {
  }

  onAcceptDelete(item: any) {
    console.info(item)
  }

  downloadFile(file: any): void {
    fetch(file.fileUrl)
      .then((response) => response.blob())
      .then((blob) => {
        const link = document.createElement('a');
        link.href = globalThis.URL.createObjectURL(blob);
        link.target = '_blank';
        link.download = file.fileName;
        document.body.appendChild(link);
        link.click();
        link.remove()
      })
      .catch((error) => console.error('Download error:', error));
  }

  selectButton(id: number) {
    this.selectedId = id;

    this.filteredFiles = this.files.filter((f) => f.type === this.selectedId);
  }

  onSaveFile(event: any) {
   console.log("selected file response :",event);
  }
}
